import { render, staticRenderFns } from "./matchPlate.vue?vue&type=template&id=8b10c9dc&scoped=true&"
import script from "./matchPlate.vue?vue&type=script&lang=js&"
export * from "./matchPlate.vue?vue&type=script&lang=js&"
import style0 from "./matchPlate.vue?vue&type=style&index=0&id=8b10c9dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b10c9dc",
  null
  
)

export default component.exports